import React from "react";
import { Link } from "gatsby";
import { Facebook, Instagram, Mail, MapPin, Phone, Linkedin } from "lucide-react";
import { StaticImage } from "gatsby-plugin-image";

const TikTokIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] text-gray-400 py-16 border-t border-gray-900">
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12">
        
        {/* Brand Column */}
        <div className="space-y-4">
          <StaticImage src="../../images/logo-new.png" alt="Logo" className="h-24 w-64" objectFit="contain"/>

          <p className="text-sm leading-relaxed">
            Leading the way in professional bartending education. Mastering the art of mixology with passion and precision.
          </p>
          <div className="flex space-x-4 pt-2">
            <a href="https://www.instagram.com/ceylon_bar_academy?igsh=MXZmMXJoOXVuazVueg==" target="_blank" rel="noopener noreferrer" className="hover:text-maroon-500 transition-colors"><Instagram size={20} /></a>
            <a href="https://www.facebook.com/share/1C6tptvpH4/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="hover:text-maroon-500 transition-colors"><Facebook size={20} /></a>
            <a href="https://www.tiktok.com/@ceylonbaracademy?_r=1&_t=ZS-937CEwIei0u" target="_blank" rel="noopener noreferrer" className="hover:text-maroon-500 transition-colors"><TikTokIcon size={20} /></a>
            <a href="https://www.linkedin.com/company/ceylon-bar-academy/" target="_blank" rel="noopener noreferrer" className="hover:text-maroon-500 transition-colors"><Linkedin size={20} /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-white font-semibold uppercase tracking-wider mb-6">Explore</h3>
          <ul className="space-y-3 text-sm">
            <li><Link to="/courses" className="hover:text-maroon-500 transition-colors">Our Courses</Link></li>
            <li><Link to="/about-us" className="hover:text-maroon-500 transition-colors">About Us</Link></li>
            <li><Link to="/contact-us" className="hover:text-maroon-500 transition-colors">Contact Us</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-maroon-500 transition-colors">Privacy Policy</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-white font-semibold uppercase tracking-wider mb-6">Contact</h3>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start space-x-3">
              <MapPin size={18} className="text-maroon-600 mt-1 shrink-0" />
              <span> No. 69, Old Kottawa Road, Mirihana<br />Sri Lanka</span>
            </li>
            <li className="flex items-center space-x-3">
              <Phone size={18} className="text-maroon-600 shrink-0" />
              <a href="tel:+94740433836" className="text-gray-400 hover:text-maroon-400 transition-colors">+94 74 043 3836</a>
            </li>
            <li className="flex items-center space-x-3">
              <Mail size={18} className="text-maroon-600 shrink-0" />
              <a href="mailto:admin@ceylonbaracademy.lk" className="text-gray-400 hover:text-maroon-400 transition-colors">admin@ceylonbaracademy.lk</a>
            </li>
          </ul>
        </div>

      </div>
      
      <div className="container mx-auto px-6 mt-16 pt-8 border-t border-gray-900 text-center text-xs text-gray-600">
        &copy; {new Date().getFullYear()} Ceylon Bar Academy. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
